import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.9, delay, ease: [0.76, 0, 0.24, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, align = 'left' }) => (
  <div className={`mb-14 md:mb-20 ${align === 'center' ? 'text-center' : ''}`} data-testid={`heading-${eyebrow.toLowerCase().replace(/\s+/g, '-')}`}>
    <Reveal>
      <span className="text-gold text-xs font-medium uppercase tracking-[0.35em]">{eyebrow}</span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mt-4 leading-[1.08]">{title}</h2>
    </Reveal>
    <Reveal delay={0.2}>
      <div className={`h-px w-20 bg-gold/60 mt-7 ${align === 'center' ? 'mx-auto' : ''}`} />
    </Reveal>
  </div>
);
